'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(require('smooth-scrollbar'));

var version = "0.0.0";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component$1 = videojs.getComponent('Component');
var NavigationMenu = videojs.getComponent('NavigationMenu');
var NavigationContent = videojs.getComponent('NavigationContent');
var paramsPlayer = {};
var isOpened = void 0;

var NavigationContainer = function (_Component) {
  inherits(NavigationContainer, _Component);

  function NavigationContainer(player, options) {
    classCallCheck(this, NavigationContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    paramsPlayer = options;
    isOpened = false;

    // If a `text` option was passed in, update the text content of
    // the component.
    _this.closeNavigation("start");
    _this.addChild('NavigationContent', NavigationContent);
    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationContainer.prototype.createEl = function createEl() {
    var ipad = "";
    if (videojs.browser.IS_IPAD || videojs.browser.IE_VERSION) {
      ipad = "iPad";
    }
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-navigation-container ' + ipad
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  NavigationContainer.prototype.openNavigation = function openNavigation(type) {
    this.player().getChild('NavigationMenu').hide();
    this.addClass('vjs-navigation-container-show');
    this.player().addClass('vjs-navigation-container-show');
    this.addChild('NavigationMenu', paramsPlayer);
    this.getChild('NavigationMenu').setMenuHorizontal();
    this.getChild('NavigationContent').setContent(type);
    try {
      document.querySelector('#annotation-wrapper').classList.add('vjs-navigation-container-visible');
    } catch (e) {}
    this._fixAnnotationsPosition('open');
    isOpened = true;
  };

  NavigationContainer.prototype.closeNavigation = function closeNavigation(start) {
    this.removeClass('vjs-navigation-container-show');
    this.player().removeClass('vjs-navigation-container-show');
    this.player().getChild('NavigationMenu').show();
    this.removeChild('NavigationMenu');
    this.player().getChild('NavigationMenu').setMenuVertical(start);
    try {
      document.querySelector('#annotation-wrapper').classList.remove('vjs-navigation-container-visible');
    } catch (e) {}
    this._fixAnnotationsPosition('close');
    isOpened = false;
  };

  NavigationContainer.prototype._fixAnnotationsPosition = function _fixAnnotationsPosition(action) {
    if (action === 'close' && !isOpened || action === 'open' && isOpened) {
      return;
    }
    var parent = document.getElementById('annotation-wrapper');

    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];

      var top = +child.style.top.slice(0, -1);
      var left = +child.style.left.slice(0, -1);
      if (action === 'open') {
        top *= 0.75;

        top += 12.5;
        left *= 0.75;
      } else {
        top -= 12.5;
        left /= 0.75;

        top /= 0.75;
      }
      parent.children[i].style.top = top + '%';
      parent.children[i].style.left = left + '%';
    }
  };

  return NavigationContainer;
}(Component$1);

var Component$2 = videojs.getComponent('Component');
var dom = videojs.dom || videojs;
var NavigationMenuItem = videojs.getComponent('NavigationMenuItem');
var percentWidth = 50;

var NavigationMenu$1 = function (_Component) {
  inherits(NavigationMenu, _Component);

  function NavigationMenu(player, options) {
    classCallCheck(this, NavigationMenu);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.player = player;
    _this.menuItem = _this.options.menuOptions;
    _this.addClass('vjs-navigation-show');
    _this.addClass('vjs-navigation-menu-vertical');
    _this.updateMenuContent(_this.options);
    //this.updateMenuContent({id:0,icon:'help',name:'help'});

    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationMenu.prototype.createEl = function createEl() {
    //const menuButton = new NavigationMenuItem();
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: 'vjs-navigation-menu'
    });
  };

  NavigationMenu.prototype.updateMenuContent = function updateMenuContent(paramPlayer) {
    var options = [{
      nav: 'search',
      placeholder: 'Rechercher',
      id: 'search-navigation-button',
      icon: 'search',
      options: paramPlayer.searchOptions
    },
    /*  {
          nav: 'playlistUep',
          placeholder: 'Playlists',
          id: 'playlist-navigation-button',
          icon: 'playlist',
          children: [{
              child: "playlistMenu",
              type: "component",
              options: {chapters: paramPlayer.rmOptions.chapters}
          }]
      },*/
    {

      /*nav: 'share',
      placeholder: 'Partager',
      id: 'share-navigation-button',
      icon: 'share',*/
      nav: 'info',
      placeholder: 'Info',
      id: 'info-navigation-button',
      icon: 'info',
      children: [{
        child: "info",
        type: "plugin",
        options: paramPlayer.infoOptions
      }, {
        child: "shareSocialMedia",
        type: "plugin",
        options: paramPlayer.shareOptions
      }, {
        child: "sendMail",
        type: "plugin",
        options: paramPlayer.sendMailOptions
      }, {
        child: "exportShare",
        type: "plugin",
        options: paramPlayer.exportOptions
      }]
    }, {
      nav: 'comments',
      placeholder: 'Commentaire',
      id: 'comments-navigation-button',
      icon: 'comment',
      options: paramPlayer.commentsOptions
    }, {
      nav: 'files',
      placeholder: 'Fichiers',
      id: 'files-navigation-button',
      icon: 'files',
      options: paramPlayer.filesOptions
    }, {
      nav: 'richMedia',
      placeholder: 'RichMedia',
      id: 'richMedia-navigation-button',
      icon: 'chapters',
      children: [{
        child: "chapters",
        type: "component",
        options: { chapters: paramPlayer.rmOptions ? paramPlayer.rmOptions.chapters : null }
      }]
    }, {
      nav: 'survey',
      placeholder: 'Sondage',
      id: 'survey-navigation-button',
      icon: 'survey',
      options: paramPlayer.surveyOptions
    }, {
      nav: 'close',
      placeholder: 'Fermer',
      id: 'close-navigation-button',
      icon: 'close'
    }];
    var item = void 0;
    for (var i = 0; i < options.length; i++) {
      var hasPlugin = this.menuItem.indexOf(options[i].nav) > -1;
      if (hasPlugin) {
        item = this.addChild('NavigationMenuItem', options[i]);
      }
    }

    //dom.addChild(this.el(),'NavigationMenuItem');
    //dom.addChild(this.el(), "test");
    // If no text was provided, default to "Title Unknown"


    // Use Video.js utility DOM methods to manipulate the content
    // of the component's element.
    // this.player().emptyEl(this.el());
    // this.player().appendContent(this.el(), text);
  };

  NavigationMenu.prototype.setMenuHorizontal = function setMenuHorizontal() {
    if (this.hasClass('vjs-navigation-menu-vertical')) {
      this.removeClass('vjs-navigation-menu-vertical');
      this.addClass('vjs-navigation-menu-horizontal');
      var slide = document.getElementById('vjs-slide-items');
      if (this.player["richMedia"] && slide) {
        var videos = document.getElementsByClassName('vjs-tech');
        var video = videos && videos[0] ? videos[0] : null;
        var posters = document.getElementsByClassName('vjs-poster');
        var poster = posters && posters[0] ? posters[0] : null;

        if (video.style.width !== "") {
          percentWidth = video.style.width.replace("%", "");
        }
        if (video) {
          video.style.width = percentWidth / 100 * 75 + "%";
          poster.style.width = percentWidth / 100 * 75 + "%";
          //video.style.left = "35%";
        }
        if (slide) slide.style.width = (100 - percentWidth) / 100 * 75 + "%";
      }
    }
  };

  NavigationMenu.prototype.setMenuVertical = function setMenuVertical(start) {
    if (this.hasClass('vjs-navigation-menu-horizontal')) {
      this.removeClass('vjs-navigation-menu-horizontal');
      this.addClass('vjs-navigation-menu-vertical');
    }
    var slide = document.getElementById('vjs-slide-items');
    if (this.player["richMedia"] && slide && start !== "start") {
      var videos = document.getElementsByClassName('vjs-tech');
      var video = videos && videos[0] ? videos[0] : null;
      var posters = document.getElementsByClassName('vjs-poster');
      var poster = posters && posters[0] ? posters[0] : null;

      if (video.style.width !== "") {
        percentWidth = video.style.width.replace("%", "");
      }
      if (video) {
        video.style.width = percentWidth / 75 * 100 + "%";
        video.style.left = "0";
        poster.style.width = percentWidth / 75 * 100 + "%";
        poster.style.left = "0";
      }
      if (slide) {
        slide.style.width = (75 - percentWidth) / 75 * 100 + "%";
      }
    }
  };

  NavigationMenu.prototype.ready = function ready() {
    //dom.addChild(this.el(),'NavigationMenuItem')
  };

  return NavigationMenu;
}(Component$2);

var attach = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"13\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 20.33403503894806 1.9999608397483826 C 20.33403503894806 1.9999608397483826 6.888384103775024 1.9999608397483826 6.888384103775024 1.9999608397483826 C 4.188819408416748 1.9999608397483826 1.9998072385787964 4.237595856189728 1.9998072385787964 6.9999611377716064 C 1.9998072385787964 9.762286305427551 4.188819408416748 11.99996143579483 6.888384103775024 11.99996143579483 C 6.888384103775024 11.99996143579483 19.11123502254486 11.99996143579483 19.11123502254486 11.99996143579483 C 19.11123502254486 11.99996143579483 19.11123502254486 10.749971389770508 19.11123502254486 10.749971389770508 C 19.11123502254486 10.749971389770508 6.888384103775024 10.749971389770508 6.888384103775024 10.749971389770508 C 4.858901381492615 10.749971389770508 3.2226072549819946 9.071725070476532 3.2226072549819946 6.9999611377716064 C 3.2226072549819946 4.928197205066681 4.858901381492615 3.249990999698639 6.888384103775024 3.249990999698639 C 6.888384103775024 3.249990999698639 20.33403503894806 3.249990999698639 20.33403503894806 3.249990999698639 C 21.67789089679718 3.249990999698639 22.77701187133789 4.379077672958374 22.77701187133789 5.749971091747284 C 22.77701187133789 7.126440346240997 21.67789089679718 8.249951183795929 20.33403503894806 8.249951183795929 C 20.33403503894806 8.249951183795929 9.334081292152405 8.249951183795929 9.334081292152405 8.249951183795929 C 8.66127896308899 8.249951183795929 8.111281275749207 7.684906423091888 8.111281275749207 6.999921023845673 C 8.111281275749207 6.314935624599457 8.66127896308899 5.74993097782135 9.334081292152405 5.74993097782135 C 9.334081292152405 5.74993097782135 19.11123502254486 5.74993097782135 19.11123502254486 5.74993097782135 C 19.11123502254486 5.74993097782135 19.11123502254486 4.499900817871094 19.11123502254486 4.499900817871094 C 19.11123502254486 4.499900817871094 9.334081292152405 4.499900817871094 9.334081292152405 4.499900817871094 C 7.987505078315735 4.499900817871094 6.888384103775024 5.623411655426025 6.888384103775024 6.999880909919739 C 6.888384103775024 8.376310050487518 7.987505078315735 9.499861001968384 9.334081292152405 9.499861001968384 C 9.334081292152405 9.499861001968384 20.33403503894806 9.499861001968384 20.33403503894806 9.499861001968384 C 22.36351776123047 9.499861001968384 23.99981188774109 7.827270746231079 23.99981188774109 5.749890863895416 C 23.99981188774109 3.6782071590423584 22.36351776123047 1.9999608397483826 20.33403503894806 1.9999608397483826 Z\"/></g></svg>";

var share = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"23\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 17.831345200538635 16.137431859970093 C 17.02981173992157 16.137431859970093 16.31241500377655 16.436601519584656 15.765817761421204 16.90826106071472 C 15.765817761421204 16.90826106071472 8.238495588302612 12.743272244930267 8.238495588302612 12.743272244930267 C 8.292805552482605 12.512456715106964 8.334873914718628 12.27995640039444 8.334873914718628 12.039954781532288 C 8.334873914718628 11.799913048744202 8.29193115234375 11.568255126476288 8.238495588302612 11.336597204208374 C 8.238495588302612 11.336597204208374 15.680806636810303 7.2107595801353455 15.680806636810303 7.2107595801353455 C 16.24838948249817 7.710739552974701 16.99911057949066 8.023227035999298 17.831345200538635 8.023227035999298 C 19.585877656936646 8.023227035999298 20.99978268146515 6.680734276771545 20.99978268146515 5.011553704738617 C 20.99978268146515 3.3457828164100647 19.58500325679779 1.9999204874038696 17.831345200538635 1.9999204874038696 C 16.08021318912506 1.9999204874038696 14.665530920028687 3.3457828164100647 14.665530920028687 5.010791540145874 C 14.665530920028687 5.254122614860535 14.708473682403564 5.48245108127594 14.761909246444702 5.714109003543854 C 14.761909246444702 5.714109003543854 7.319598197937012 9.84327608346939 7.319598197937012 9.84327608346939 C 6.751043796539307 9.340768933296204 6.001294255256653 9.029083728790283 5.168185234069824 9.029083728790283 C 3.41355562210083 9.029083728790283 1.9997477531433105 10.374143779277802 1.9997477531433105 12.039954781532288 C 1.9997477531433105 13.70572566986084 3.41355562210083 15.051587998867035 5.168185234069824 15.051587998867035 C 6.000322699546814 15.051587998867035 6.751043796539307 14.739060401916504 7.318723797798157 14.239080429077148 C 7.318723797798157 14.239080429077148 14.83283281326294 18.41325533390045 14.83283281326294 18.41325533390045 C 14.781146049499512 18.625778913497925 14.748696088790894 18.84740835428238 14.748696088790894 19.06827563047409 C 14.748696088790894 20.68498718738556 16.1336487531662 21.9999617934227 17.830373644828796 21.9999617934227 C 19.528944492340088 21.9999617934227 20.914674401283264 20.685789465904236 20.914674401283264 19.06827563047409 C 20.914674401283264 17.450761795043945 19.529818892478943 16.137431859970093 17.831345200538635 16.137431859970093 Z\"/></g></svg>\n";

var survey = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 384 384\" style=\"enable-background:new 0 0 384 384;\" xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M341.333,0H42.667C19.093,0,0,19.093,0,42.667v298.667C0,364.907,19.093,384,42.667,384h298.667\n\t\t\tC364.907,384,384,364.907,384,341.333V42.667C384,19.093,364.907,0,341.333,0z M128,298.667H85.333V149.333H128V298.667z\n\t\t\t M213.333,298.667h-42.667V85.333h42.667V298.667z M298.667,298.667H256v-85.333h42.667V298.667z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var close = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"348.333px\" height=\"348.334px\" viewBox=\"0 0 348.333 348.334\" style=\"enable-background:new 0 0 348.333 348.334;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85\n\t\tc-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563\n\t\tc-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85\n\t\tl105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554\n\t\tL279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var comment = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 60 60\" style=\"enable-background:new 0 0 60 60;\" xml:space=\"preserve\">\n<path d=\"M30,1.5c-16.542,0-30,12.112-30,27c0,5.204,1.646,10.245,4.768,14.604c-0.591,6.537-2.175,11.39-4.475,13.689\n\tc-0.304,0.304-0.38,0.769-0.188,1.153C0.275,58.289,0.625,58.5,1,58.5c0.046,0,0.092-0.003,0.139-0.01\n\tc0.405-0.057,9.813-1.411,16.618-5.339C21.621,54.71,25.737,55.5,30,55.5c16.542,0,30-12.112,30-27S46.542,1.5,30,1.5z M16,32.5\n\tc-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,32.5,16,32.5z M30,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4\n\tS32.206,32.5,30,32.5z M44,32.5c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S46.206,32.5,44,32.5z\"/>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var info = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n<path d=\"M256,0C114.613,0,0,114.617,0,256c0,141.391,114.613,256,256,256s256-114.609,256-256C512,114.617,397.387,0,256,0z\n\t M256,128c17.674,0,32,14.328,32,32c0,17.68-14.326,32-32,32s-32-14.32-32-32C224,142.328,238.326,128,256,128z M304,384h-96\n\tc-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h16v-96h-16c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h64\n\tc8.836,0,16,7.164,16,16v112h16c8.836,0,16,7.164,16,16C320,376.844,312.836,384,304,384z\"/>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var files$1 = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"22px\" height=\"21px\" viewBox=\"0 0 45 45\" style=\"enable-background:new 0 0 45 45;\" xml:space=\"preserve\">\n<g>\n\t<path d=\"M44.449,16.561c-0.475-0.591-1.191-0.936-1.949-0.936H40c0-1.381-1.119-2.5-2.5-2.5H35v-2.5c0-1.381-1.119-2.5-2.5-2.5\n\t\th-1.25v-5c0-0.69-0.561-1.25-1.25-1.25H5c-0.691,0-1.25,0.56-1.25,1.25v5H2.5c-1.381,0-2.5,1.119-2.5,2.5v30\n\t\tc0,1.381,1.119,2.5,2.5,2.5h5h25h5c1.172,0,2.188-0.814,2.439-1.958l5-22.5C45.105,17.927,44.924,17.152,44.449,16.561z\n\t\t M3.75,40.625H2.5v-30h1.25V40.625z M31.468,28.469l-8.75,8.749c-0.488,0.488-1.279,0.488-1.768,0l-8.75-8.75\n\t\tc-0.357-0.356-0.465-0.895-0.271-1.362c0.193-0.467,0.648-0.771,1.154-0.771h3.125V15.626H12.5c-1.172,0-2.188,0.814-2.441,1.958\n\t\tc0,0-5.057,22.861-5.057,23.042H5v-37.5h25v10c-1.381,0-2.5,1.119-2.5,2.5h-0.042v10.71h3.125c0.506,0,0.961,0.305,1.155,0.771\n\t\tC31.934,27.574,31.825,28.111,31.468,28.469z M32.5,13.125h-1.25v-2.5h1.25V13.125z M8.667,7.417c0-0.69,0.56-1.25,1.25-1.25\n\t\th14.916c0.69,0,1.25,0.56,1.25,1.25s-0.56,1.25-1.25,1.25H9.917C9.228,8.667,8.667,8.107,8.667,7.417z M24.833,13.75H9.917\n\t\tc-0.69,0-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25h14.916c0.69,0,1.25,0.56,1.25,1.25S25.523,13.75,24.833,13.75z\"/>\n</svg>\n";

var playlist = "﻿<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"22\" height=\"21\"><defs/><g><path fill=\"rgb(159,159,159)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 1.9999184608459473 7.142806768417358 C 1.9999184608459473 7.142806768417358 17.199907541275024 7.142806768417358 17.199907541275024 7.142806768417358 C 17.199907541275024 7.142806768417358 17.199907541275024 9.714269876480103 17.199907541275024 9.714269876480103 C 17.199907541275024 9.714269876480103 1.9999184608459473 9.714269876480103 1.9999184608459473 9.714269876480103 C 1.9999184608459473 9.714269876480103 1.9999184608459473 7.142806768417358 1.9999184608459473 7.142806768417358 Z M 1.9999184608459473 1.9999607801437378 C 1.9999184608459473 1.9999607801437378 17.199907541275024 1.9999607801437378 17.199907541275024 1.9999607801437378 C 17.199907541275024 1.9999607801437378 17.199907541275024 4.571423888206482 17.199907541275024 4.571423888206482 C 17.199907541275024 4.571423888206482 1.9999184608459473 4.571423888206482 1.9999184608459473 4.571423888206482 C 1.9999184608459473 4.571423888206482 1.9999184608459473 1.9999607801437378 1.9999184608459473 1.9999607801437378 Z M 1.9999184608459473 12.285692870616913 C 1.9999184608459473 12.285692870616913 12.133244514465332 12.285692870616913 12.133244514465332 12.285692870616913 C 12.133244514465332 12.285692870616913 12.133244514465332 14.857155978679657 12.133244514465332 14.857155978679657 C 12.133244514465332 14.857155978679657 1.9999184608459473 14.857155978679657 1.9999184608459473 14.857155978679657 C 1.9999184608459473 14.857155978679657 1.9999184608459473 12.285692870616913 1.9999184608459473 12.285692870616913 Z M 14.666478872299194 12.285692870616913 C 14.666478872299194 12.285692870616913 14.666478872299194 19.999961853027344 14.666478872299194 19.999961853027344 C 14.666478872299194 19.999961853027344 20.9998562335968 16.14280730485916 20.9998562335968 16.14280730485916 C 20.9998562335968 16.14280730485916 14.666478872299194 12.285692870616913 14.666478872299194 12.285692870616913 Z\"/></g></svg>";

var search = "﻿<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"30.239px\" height=\"30.239px\" viewBox=\"0 0 30.239 30.239\" style=\"enable-background:new 0 0 30.239 30.239;\"\n\t xml:space=\"preserve\">\n<g>\n\t<path d=\"M20.194,3.46c-4.613-4.613-12.121-4.613-16.734,0c-4.612,4.614-4.612,12.121,0,16.735\n\t\tc4.108,4.107,10.506,4.547,15.116,1.34c0.097,0.459,0.319,0.897,0.676,1.254l6.718,6.718c0.979,0.977,2.561,0.977,3.535,0\n\t\tc0.978-0.978,0.978-2.56,0-3.535l-6.718-6.72c-0.355-0.354-0.794-0.577-1.253-0.674C24.743,13.967,24.303,7.57,20.194,3.46z\n\t\t M18.073,18.074c-3.444,3.444-9.049,3.444-12.492,0c-3.442-3.444-3.442-9.048,0-12.492c3.443-3.443,9.048-3.443,12.492,0\n\t\tC21.517,9.026,21.517,14.63,18.073,18.074z\"/>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var chapters = "<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\n<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"511.626px\" height=\"511.627px\" viewBox=\"0 0 511.626 511.627\" style=\"enable-background:new 0 0 511.626 511.627;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<path d=\"M118.771,200.999H27.406c-7.611,0-14.084,2.664-19.414,7.994C2.663,214.32,0,220.791,0,228.407v54.823\n\t\t\tc0,7.61,2.663,14.078,7.992,19.406c5.33,5.329,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.665,19.414-7.994\n\t\t\tc5.33-5.328,7.992-11.796,7.992-19.406v-54.823c0-7.616-2.662-14.087-7.992-19.414S126.382,200.999,118.771,200.999z\"/>\n\t\t<path d=\"M118.771,54.814H27.406c-7.611,0-14.084,2.663-19.414,7.993C2.663,68.137,0,74.61,0,82.221v54.821\n\t\t\tc0,7.616,2.663,14.091,7.992,19.417c5.33,5.327,11.803,7.994,19.414,7.994h91.365c7.611,0,14.084-2.667,19.414-7.994\n\t\t\ts7.992-11.798,7.992-19.414V82.225c0-7.611-2.662-14.084-7.992-19.417C132.855,57.48,126.382,54.814,118.771,54.814z\"/>\n\t\t<path d=\"M118.771,347.177H27.406c-7.611,0-14.084,2.662-19.414,7.994C2.663,360.502,0,366.974,0,374.585v54.826\n\t\t\tc0,7.61,2.663,14.086,7.992,19.41c5.33,5.332,11.803,7.991,19.414,7.991h91.365c7.611,0,14.084-2.663,19.414-7.991\n\t\t\tc5.33-5.324,7.992-11.8,7.992-19.41v-54.826c0-7.611-2.662-14.083-7.992-19.411S126.382,347.177,118.771,347.177z\"/>\n\t\t<path d=\"M484.215,200.999H210.131c-7.614,0-14.084,2.664-19.414,7.994s-7.992,11.798-7.992,19.414v54.823\n\t\t\tc0,7.61,2.662,14.078,7.992,19.406c5.327,5.329,11.8,7.994,19.414,7.994h274.091c7.61,0,14.085-2.665,19.41-7.994\n\t\t\tc5.332-5.328,7.994-11.796,7.994-19.406v-54.823c0-7.616-2.662-14.087-7.997-19.414\n\t\t\tC498.3,203.663,491.833,200.999,484.215,200.999z\"/>\n\t\t<path d=\"M484.215,347.177H210.131c-7.614,0-14.084,2.662-19.414,7.994c-5.33,5.331-7.992,11.8-7.992,19.41v54.823\n\t\t\tc0,7.611,2.662,14.089,7.992,19.417c5.327,5.328,11.8,7.987,19.414,7.987h274.091c7.61,0,14.085-2.662,19.41-7.987\n\t\t\tc5.332-5.331,7.994-11.806,7.994-19.417v-54.823c0-7.61-2.662-14.085-7.997-19.41C498.3,349.846,491.833,347.177,484.215,347.177z\n\t\t\t\"/>\n\t\t<path d=\"M503.629,62.811c-5.329-5.327-11.797-7.993-19.414-7.993H210.131c-7.614,0-14.084,2.663-19.414,7.993\n\t\t\ts-7.992,11.803-7.992,19.414v54.821c0,7.616,2.662,14.083,7.992,19.414c5.327,5.327,11.8,7.994,19.414,7.994h274.091\n\t\t\tc7.61,0,14.078-2.667,19.41-7.994s7.994-11.798,7.994-19.414V82.225C511.626,74.613,508.964,68.141,503.629,62.811z\"/>\n\t</g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n<g>\n</g>\n</svg>\n";

var Button = videojs.getComponent('Button');
var icons = {
  attach: attach,
  share: share,
  survey: survey,
  close: close,
  comment: comment,
  info: info,
  playlist: playlist,
  search: search,
  chapters: chapters,
  files: files$1
};
/**
 * send mail button.
 */

var NavigationMenuItem$1 = function (_Button) {
  inherits(NavigationMenuItem, _Button);

  function NavigationMenuItem(player, options) {
    classCallCheck(this, NavigationMenuItem);

    // document.getElementsByTagName('html')[0].style.setProperty("content",options.icon);
    // this.id_
    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-navigation-menu-item');
    _this.addClass('vjs-icon-button');
    _this.addClass(options.id);
    _this.options = options;
    _this.controlText(options.placeholder);
    var wrapper = document.createElement('div');
    wrapper.innerHTML = '<div>' + icons[options.icon] + '</div>';
    videojs.dom.appendContent(_this.el(), wrapper.firstChild);
    return _this;
  }

  NavigationMenuItem.prototype.handleClick = function handleClick() {
    //change the navigation content
    if (this.hasClass('close-navigation-button')) {
      this.closeNavigation();
    } else {
      if (this.player().getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
        this.player().getChild('NavigationContainer').getChild('NavigationContent').setContent(this.options);
      } else {
        this.player().getChild('NavigationContainer').openNavigation(this.options);
      }
    }
  };

  NavigationMenuItem.prototype.closeNavigation = function closeNavigation() {
    if (this.player().getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
      this.player().getChild('NavigationContainer').closeNavigation();
    }
  };

  return NavigationMenuItem;
}(Button);

var Component$3 = videojs.getComponent('Component');

var optionsScroll = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var NavigationContent$1 = function (_Component) {
  inherits(NavigationContent, _Component);

  function NavigationContent(player, options) {
    classCallCheck(this, NavigationContent);

    // If a `text` option was passed in, update the text content of
    // the component.
    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.lastChild = [];
    _this.history = [];
    _this.mailListener(_this);
    return _this;
  }

  // The `createEl` function of a component creates its DOM element.


  NavigationContent.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {

      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      id: "navigation-content",
      className: 'vjs-navigation-content'
    });
  };

  // This function could be called at any time to update the text
  // contents of the component.


  NavigationContent.prototype.mailListener = function mailListener(self) {
    this.player.on('mailWindow', function (e) {
      self.toggleClass('vjs-mail-share-open');
    });
  };

  NavigationContent.prototype.setContent = function setContent(navigationButton) {
    if (window.scrollBarNavigation) {
      window.scrollBarNavigation.destroy();
      window.scrollBarNavigation = null;
    }
    var options_plugin = [];
    var s;
    if (this.lastChild.length > 0) {
      for (var i = 0; i < this.lastChild.length; i++) {
        this.removeClass(this.lastChild[i] + '-navigation-show');
        this.player.getChild('NavigationContainer').getChild('NavigationMenu').removeClass('vjs-navigation-menu__' + this.lastChild[i]);
      }
      this.lastChild = [];
    }
    if (this.history.indexOf(navigationButton.nav) === -1) {
      addingHistory(this.history, navigationButton.nav);
      showContent(this, this.lastChild, navigationButton.nav, this.player);
      if (navigationButton.children) {
        for (var i = 0; i < navigationButton.children.length; i++) {
          if (navigationButton.children[i].type === "plugin") {
            if (this.player[navigationButton.children[i].child]) {
              options_plugin = _typeof(navigationButton.children[i].options) !== undefined && navigationButton.children[i].options !== "" ? navigationButton.children[i].options : [];
              var child = this.addChild(navigationButton.children[i].child, options_plugin);
            }
          } else if (navigationButton.children[i].type === "component") {
            if (this.player[navigationButton.nav]) {
              options_plugin = _typeof(navigationButton.children[i].options) !== undefined && navigationButton.children[i].options !== "" ? navigationButton.children[i].options : [];
              this.addChild(navigationButton.children[i].child, options_plugin);
            }
          }
        }

        s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
        window.scrollBarNavigation = s;
      } else if (navigationButton && navigationButton.nav && this.player[navigationButton.nav]) {
        if (!this.getChild(navigationButton.nav)) {
          options_plugin = _typeof(navigationButton.options) !== undefined ? navigationButton.options : [];
          this.addChild(navigationButton.nav, options_plugin);
          if (typeof options_plugin.noScroll === "undefined") {
            s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
            window.scrollBarNavigation = s;
          }
        }
      }
    } else {
      showContent(this, this.lastChild, navigationButton.nav, this.player);
      if (navigationButton.children) {
        s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
        window.scrollBarNavigation = s;
      } else {
        options_plugin = _typeof(navigationButton.options) !== undefined ? navigationButton.options : [];
        if (typeof options_plugin.noScroll === "undefined") {
          s = Scrollbar.init(document.querySelector('#navigation-content'), optionsScroll);
          window.scrollBarNavigation = s;
        }
      }
    }

    function addingHistory(history, nav) {
      history.push(nav);
    }

    function showContent(parent, lastChild, nav, player) {
      lastChild.push(nav);
      parent.addClass(nav + '-navigation-show');
      player.getChild('NavigationContainer').getChild('NavigationMenu').addClass('vjs-navigation-menu__' + nav);
    }
  };

  return NavigationContent;
}(Component$3);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
var Component = videojs.getComponent('Component');
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

videojs.registerComponent('NavigationContainer', NavigationContainer);
videojs.registerComponent('NavigationContent', NavigationContent$1);
videojs.registerComponent('NavigationMenu', NavigationMenu$1);
videojs.registerComponent('NavigationMenuItem', NavigationMenuItem$1);
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-navigation');
  player.addChild('NavigationMenu', options);
  player.addChild('NavigationContainer', options);
  // Get the Component base class from Video.js
  // The videojs.extend function is used to assist with inheritance. In
  // an ES6 environment, `class TitleBar extends Component` would work
  // identically.


  // Create a player.

  // Add the TitleBar as a child of the player and provide it some text
  // in its options.
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function navigation
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var navigation = function navigation(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('navigation', navigation);

// Include the version number.
navigation.VERSION = version;

module.exports = navigation;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_navigation/dist/videojs-navigation.cjs.js
// module id = 810
// module chunks = 0